import { createRouter, createWebHistory } from "vue-router";
import { useConfigStore } from "@/store/config";
import { useDevice } from "@/composables/useDeviceType";
import { useLoadingStore } from "@/store/loading";
import { HomeAPI } from "@/api";
const { deviceType, windowWidth } = useDevice();

/**
 * meta:
 * title:*.title 頁面標題
 * requiresAuth: true,  需要驗證才能進入
 */
const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "Global.title",
      requiresAuth: true,
    },
  },
  {
    path: "/onlyweb",
    name: "onlyweb",
    component: () => import("@/views/404/onlyweb.vue"),
    meta: {
      title: "hint.title",
      requiresAuth: false,
    },
  },
  {
    path: "/member",
    name: "member",
    component: () => import("@/views/member/index.vue"),
    meta: {
      title: "Member.title",
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/member/login.vue"),
    meta: {
      title: "Login.title",
      requiresAuth: false,
    },
  },
  {
    path: "/table/:id",
    name: "dynamicId",
    component: () => import("@/views/home/baccaratTable.vue"),
    meta: {
      title: "BaccaratTable.title",
      requiresAuth: true,
    },
  },
  {
    path: "/tableMobile/:id",
    name: "dynamicMobileId",
    component: () => import("@/views/home/baccaratTableMoblie.vue"),
    meta: {
      title: "BaccaratTable.title",
      requiresAuth: true,
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: () => import("@/views/404/index.vue"),
    meta: {
      title: "404.title",
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const raw = localStorage.getItem("config");
  const loading = useLoadingStore();
  const token = raw ? JSON.parse(raw).token : "";
  const tableId = raw ? JSON.parse(raw).tableId : "";
  loading.show(true);
  // 第一層 手機限制
  // if (windowWidth.value <= 576 && to.path !== "/onlyweb") {
  //   return next("/onlyweb");
  // }

  if (!token) {
    // 沒 token 只能進 login / onlyweb
    if (to.path === "/login") {
      return next();
    }
    if (to.meta.requiresAuth) {
      return next("/login");
    }
    return next();
  }

  /* =====================
   * 2 已在桌子頁，不動
   * ===================== */
  if (to.name === "dynamicId" || to.name === "dynamicMobileId") {
    const currentTableId = to.params.id;
    const isMobile = deviceType.value != "pc";
    if (isMobile && to.name === "dynamicId") {
      // console.log("🔄 切換到手機版桌子");
      return next(`/tableMobile/${currentTableId}`);
    }
    if (!isMobile && to.name === "dynamicMobileId") {
      // console.log("🔄 切換到 PC 版桌子");
      return next(`/table/${currentTableId}`);
    }

    // 設備類型匹配,不需要切換
    return next();
  }

  /* =====================
   * 3 查桌子狀態（有 token 一定查）
   * ===================== */
  if (token) {
    console.log("deviceType:", deviceType.value);
    if (to.name === "member") {
      console.log("會員中心");
      return next();
    } else if (tableId) {
      console.log("deviceType:", tableId);
      if (deviceType.value != "pc") {
        return next(`/tableMobile/${tableId}`);
      } else {
        return next(`/table/${tableId}`);
      }
    }
    // 極端保底：有 token 但沒 tableId
    return next("/");
  }
  return next();
});

/* 改變頁面標題 */
router.afterEach((to) => {
  const loadingStore = useLoadingStore();
  const Global = {
    "Global.title": "Digital Game",
    "BaccaratTable.title": "Digital Game",
    "Member.title": "會員中心",
    "Login.title": "Digital Game",
    "hint.title": "提示",
    "404.title": "找不到頁面",
  };
  const titleKey = to.meta?.title || "Global.title";
  document.title = Global[titleKey] || "Digital Game";

  setTimeout(() => {
    loadingStore.hide();
  }, 180000); // 保證關閉loading
});

export default router;
